export var Polyglot = (function() {
    let currentLocal = null;
    /**
     * Polyglot
     *
     * @constructor
     */
    function Polyglot () {
        this.dictionary = {};
        this.pushUri = null;
        this.fetchUri = null;
    }

    /* -- PUBLIC -- */

    /**
     * Fetch Polyglot's Dictionary
     *
     * @param {String} url
     * @param {function} doWhenReady 
     */
    Polyglot.prototype.fetch = function (doWhenReady) {
        var t = this;
        fetch(this.fetchUri)
            .then(function(response) {
                return response.json();
            })
            .then(function(json) {
                t.dictionary = _.merge(t.dictionary, json);

                if(doWhenReady) {
                    doWhenReady();
                }
            });
    };

    /**
     * Get Translated Text
     *
     * @param {String} untranslated
     * @param {{}} placeholders
     * @returns {String}
     */
    Polyglot.prototype.text = function (untranslated, placeholders) {
        // Get translation object, for the untranslated text:
        var translation = translationObject(this, untranslated);


        // If not found, we return the untranslated (but we do insert the
        // placeholders before we return)
        if ( ! translation) {
            pushUntranslated(this, untranslated, false);
            return insertPlaceholders(untranslated, placeholders);
        }

        if(! translation.str) {
            return insertPlaceholders(untranslated, placeholders);
        }
        
        // If still here, we have found a translation. Note however that
        // this translation might contain multiple translated texts (for
        // plural forms). This should not happen, since such a text should
        // be called with plural() instead of text(). We'll default to the
        // first text encountered, if this occurs:
        if (typeof translation.str == 'object') {
            for (var i in translation.str) {
                return insertPlaceholders(translation.str[i], placeholders);
            }
        }

        // If still here, it is a regular translation. So, return:
        return insertPlaceholders(translation.str, placeholders);
    };

    /**
     * Get Plural Text. Note that this will rely on the default plural formula
     * of Germanic languages. Other plural formulas are not supported at the moment.
     *
     * @param {String} untranslated
     * @param {String} untranslatedPlural
     * @param {Number} count
     * @param {{}} placeholders
     * @returns {String}
     */
    Polyglot.prototype.plural = function (untranslated, untranslatedPlural, count, placeholders) {
        // Get translation object, for the untranslated text:
        var translation = translationObject(this, untranslated);

        // First, we apply the default plural formula:
        var n = count == 1 ? 0 : 1;

        // Make sure the count is a placeholder value, too:
        placeholders = Object.assign({ count : count }, placeholders);

        // If not found, we return the untranslated text. We pick between singular
        // and plural, and we also insert placeholders:
        if ( ! translation) {
            pushUntranslated(this, untranslated, true);
            return insertPlaceholders(n == 0 ? untranslated : untranslatedPlural, placeholders);
        }

        // If still here, we have found the translation object. We'll look for the
        // appropiate plural form there. If it does not exist, again, we return the
        // untranslated string:
        found = (typeof translation.str == 'object' && typeof translation.str[n] == 'string');
        if ( ! found) {
            return insertPlaceholders(n == 0 ? untranslated : untranslatedPlural, placeholders);
        }

        // Return translated string:
        return insertPlaceholders(translation.str[n], placeholders);
    };

    /* -- PRIVATE -- */

    /**
     * Get Text, with placeholder values
     *
     * @param {String} text
     * @param {{}} placeholders
     * @returns {String}
     */
    function insertPlaceholders (text, placeholders) {
        if ( ! text) {
            return '';
        }

        var i;
        var name;

        text = text.toString();

        if (typeof placeholders != 'object') {
            return text;
        }

        for (var i in placeholders) {

            name = (i.substr(0, 1) != '@') ? '@' + i : i;
            text = text.replace(name, placeholders[i]);
        }

        return text;
    }

    function pushUntranslated(instance, text, isPlural) {
        if(! instance.pushUri) {
            return;
        }

        let data = Vue.prototype.$Api.getBaseData();
        data.string = text;

        let Formdata = new FormData();

        _.each(data,function(item,key) {
            Formdata.append(key,item);
        });

        axios.post(instance.pushUri, Formdata,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function (response) {
            instance.fetch();
        });
    }

    /**
     * Is Polyglot's Dictionary Fetched?
     *
     * @returns {boolean}
     */
    function isFetched (instance) {
        return (
            typeof instance.dictionary != 'undefined' &&
            typeof instance.dictionary.texts != 'undefined'
        );
    }

    /**
     * Get Translations, for given untranslated text
     *
     * @param {Polyglot} instance
     * @param {String} untranslated
     * @returns {{}}
     */
    function translationObject (instance, untranslated) {
        if ( ! isFetched(instance)) {
            return null;
        }

        if (typeof instance.dictionary.texts[untranslated] == 'undefined') {
            return null;
        }

        return instance.dictionary.texts[untranslated];
    }

    return Polyglot;
})();


// WEBPACK FOOTER //
// ./src/utils/polyglot.js